module.exports = __webpack_public_path__ + "static/media/heroGraphic1600.3f9b42ef.png";